export const FETCH_MEDICINES_LIST_REQUEST = "FETCH_MEDICINES_LIST_REQUEST";
export const FETCH_MEDICINES_LIST_SUCCESS = "FETCH_MEDICINES_LIST_SUCCESS";
export const FETCH_MEDICINES_LIST_FAILURE = "FETCH_MEDICINES_LIST_FAILURE";
